var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 333,
    viewBox: "0 0 1440 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 277.545C916.31 173.418 734.465 443.689 0 277.545V0H1440V277.545Z",
    fill: "#880C55"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1029_332",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 333
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 277.545C916.31 173.418 734.465 443.689 0 277.545V0H1440V277.545Z",
    fill: "#880C55"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1029_332)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1029_332",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -192,
    y: 38,
    width: 1674,
    height: 334
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1482 316.173C873.21 212.046 661.816 482.317 -192 316.173V38.6279H1482V316.173Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1029_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-192 221.754C416.79 277.982 628.184 132.036 1482 221.754L1482 371.628L-192 371.628L-192 221.754Z",
    fill: "black",
    fillOpacity: 0.12
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1029_332",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 333
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 277.545C916.31 173.418 734.465 443.689 0 277.545V0H1440V277.545Z",
    fill: "#880C55"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1029_332)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1029_332",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -55,
    y: -115,
    width: 1503,
    height: 563
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1447.14 285.262C900.019 176.961 790.106 581.081 17.5219 400.205L-55 0.114746L1374.62 -114.828L1447.14 285.262Z",
    fill: "#880C55"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1029_332)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1029_332",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 198,
    width: 1503,
    height: 563
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3056 360.393C557.429 468.695 667.342 64.5748 1439.93 245.451L1512.45 645.541L82.8275 760.484L10.3056 360.393Z",
    fill: "#44062B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1029_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1462.33 369.043C930.279 343.899 776.693 507.085 28.1601 458.893L-4.18457 280.453L1425.44 165.511L1462.33 369.043Z",
    fill: "black",
    fillOpacity: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicDecoration);
export default __webpack_public_path__ + "static/media/Public_Decoration.00c9f9a03da106092b5b939e9b8bd8fc.svg";
export { ForwardRef as ReactComponent };